import type { UserState } from '@repperjs/app/src/state/auth/@types/UserState';

export const emailVerificationSettings = {
    url: process.env.PUBLIC_FB_VERIFY_CALLBACK_URL,
};

export const needsEmailVerification = (authUser?: UserState) =>
    authUser &&
    !authUser.emailVerified &&
    authUser.providerData.map((provider) => provider.providerId).includes('password');
